import { motion } from "framer-motion";
import { PenLine, Phone } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export default function MobileCTA() {
  return (
    <motion.div
      initial={{ y: 80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, delay: 1.2 }}
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-line bg-white/95 backdrop-blur-xl md:hidden"
      data-testid="mobile-cta-bar"
    >
      <a
        href="tel:+393513937976"
        className="flex items-center justify-center gap-2 py-4 font-heading text-sm font-bold uppercase tracking-wider text-navy"
        data-testid="mobile-call-button"
      >
        <Phone className="h-4 w-4" />
        Chiama
      </a>
      <button
        onClick={() => scrollToId("#iscriviti")}
        className="flex items-center justify-center gap-2 bg-brand-amber py-4 font-heading text-sm font-bold uppercase tracking-wider text-white"
        data-testid="mobile-iscriviti-button"
      >
        <PenLine className="h-4 w-4" />
        Iscriviti
      </button>
    </motion.div>
  );
}
